import React from 'react';
import ParadigmaTable from '../../components/ParadigmaTable/ParadigmaTable';
import api from '../../api/api';
import Modal from './Modal';

const columnsProfesionales = [
    {
        Header: "id",
        id: "id",
        accessor: "id",
        width: 100,
        show: false,
        private: true,
    },
    {
        Header: "Nombre",
        id: "nombre",
        accessor: "nombre",
        show: true,
    },
    {
        Header: "Email",
        id: "email",
        accessor: "email",
        show: true,
    },
    {
        Header: "Telefono",
        id: "telefono",
        accessor: "telefono",
        show: true,
    },
    {
        Header: "Dirección",
        id: "direccionCompleta",
        accessor: "direccionCompleta",
        show: true,
    },
    {
        Header: "Categoría",
        id: "categoria",
        accessor: d => d.categoria.nombre,
        show: true,
    },
    {
        Header: "Visible",
        id: "show",
        accessor: d => d.show ? "SI" : "NO",
        show: true,
    },
];

const buttons = [
    {
        create: true,
        component: (props) => <Modal {...props} action="CREATE" />,
        // permission: 'plantillas_new',
    },
    {
        edit: true,
        component: (props) => <Modal {...props} action="EDIT" />,
        // permission: 'plantillas_edit',
    },
    {
        edit: true,
        component: (props) => <Modal {...props} action="DETAIL" />,
        // permission: 'plantillas_detail',
    },
    {
        delete: true,
        component: (props) => <Modal {...props} action="DELETE" />,
        // permission: 'plantillas_delete',
    }
];

const ProfesionalesTable = (props) =>  {

        const { modernTheme } = props;

        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={buttons}
                apiUrl={api.profesionales}
                columns={columnsProfesionales}
                title={"Profesionales"}
            />
        );
    
}

export default ProfesionalesTable;


// WEBPACK FOOTER //
// ./src/views/Profesionales/Profesionales.js